<div class="auth-container flex">
  <div class="auth-container__banner flex w-[40%]">
    <div class="auth-container__banner--logo">
      <div class="flex items-start justify-between w-full">
        <div>
          <img src="/assets/images/logo_lgs.png" alt="Logo" />
        </div>
      </div>
    </div>

    <div class="auth-container__banner--logo__developed">
      <div class="auth-container__banner--logo__developed--text mb-2">
        Developed by
      </div>
      <img src="/assets/images/logo_risk.png" alt="Logo" />
    </div>
  </div>
  <div
    class="auth-container__right-side flex w-[60%] justify-center items-center"
  >
    <div class="auth-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<aran-loading></aran-loading>
